import React, { useState } from 'react'
import { Card, CardContent, CardHeader, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { HorizontalStackedBarChart } from '../../../charts/BarChart'
import { ADHERENCE_COLORS } from '../../../charts/colors'
import MaterialTable from '../../../../common/MaterialTable'
import { numberPrecision } from '../../../../helpers/UtilityHelper'

const PickupAdherence = ({ data = [], title = 'Courier Wise Pickup Adherence', yLabel = 'Courier', subHeader = '' }) => {
    const [view, setView] = useState('chart')

    if (!data || data.length === 0) return null

    const chartOptions = {
        yaxis: 'name',
        data: [
            { dataKey: 'sameDayPickupPercentage', label: 'Same Day Pickup %', fill: ADHERENCE_COLORS.WITHIN },
            { dataKey: 'nextDayPickupPercentage', label: 'Next Day Pickup %', fill: ADHERENCE_COLORS.NOT_WITHIN },
        ],
        stackId: 'a',
        yLabel,
        showLabels: true,
        legendAlign: 'left',
    }

    const columns = [
        { label: 'Name', value: 'name', align: 'left' },
        { label: 'Same Day', value: (row) => `${row.sameDayPickup} (${numberPrecision(row.sameDayPickupPercentage)}%)` },
        { label: 'Next Day', value: (row) => `${row.nextDayPickup} (${numberPrecision(row.nextDayPickupPercentage)}%)` },
        { label: 'Total', value: 'total' },
    ]

    return (
        <Card elevation={1}>
            <CardHeader
                title={title}
                subheader={subHeader}
                action={
                    <ToggleButtonGroup
                        value={view}
                        exclusive
                        size="small"
                        onChange={(_e, v) => v && setView(v)}
                    >
                        <ToggleButton value="chart">Chart</ToggleButton>
                        <ToggleButton value="table">Table</ToggleButton>
                    </ToggleButtonGroup>
                }
            />
            <CardContent>
                {view === 'chart' ? (
                    <HorizontalStackedBarChart data={data} chartOptions={chartOptions} height={Math.max(250, data.length * 35 + 80)} />
                ) : (
                    <MaterialTable columns={columns} rows={data} />
                )}
            </CardContent>
        </Card>
    )
}

export default PickupAdherence
